module.exports = __webpack_public_path__ + "static/media/beefy.4e504f3e.svg";